module.exports = __webpack_public_path__ + "media/images/new/filter_by_reported_cell_service-bd6757efbc1de182f226856034bc665f.jpg";